export default {
  manage: {
    manage: '部门管理',
    empty: '暂无用户'
  },
  login: {
    stateRequired: '验证码不能为空',
    state: '验证码',
    username: '用户名',
    password: '密码',
    remember: '记住密码',
    logIn: '立即登录',
    forget: '忘记密码',
    usernameRequired: '用户名不能为空',
    passwordRequired: '密码不能为空',
    solutionRequired: '账套信息不能为空',
    noAccount: '没有获取到任何账套信息，请与管理员联系！',
    styleError: '获取登录样式信息失败！',
    fedLogOut: '登录已过期，请重新登录！',
    error: '请求失败！请与管理员联系获取更多信息。',
    gettingSolutions: '正在获取账套信息，请稍候...',
    expired: '密码失效',
    return: '留在本页',
    goTo: '前往修改',
    noSolution: '账套不存在，请确认地址'
  },
  dashboard: {
    flow: '流程',
    fast: '快速入口',
    noData: '暂无数据'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  buttons: {
    resume: '重新办理',
    manage: '管理',
    customButton: '自定义按钮',
    relevantReport: '相关填报',
    relatedReport: '关联填报',
    sendEmail: '发送邮件',
    lastThreeMonths: '最近三个月',
    lastMonth: '最近一个月',
    lastWeek: '最近一周',
    all: '全选',
    notify: '通知',
    total: '共',
    choosed: '选中',
    num: '条',
    batch: '选择',
    test: '测试',
    copyCreate: '复制新增',
    determine: '确定',
    urge: '催办',
    startUnfinished: '发起未结束',
    moreNote: '详情',
    lock: '锁定',
    unlock: '解锁',
    showAll: '显示全部',
    start: '发起',
    unprocessed: '提交未处理',
    upcoming: '待办',
    done: '已办',
    search: '搜索',
    advance: '高级',
    common: '普通',
    check: '查看',
    schedule: '进度',
    refresh: '刷新',
    create: '新增',
    edit: '编辑',
    delete: '删除',
    batchDelete: '批量删除',
    handle: '办理',
    rollBack: '回退',
    reDo: '撤销',
    history: '历史记录',
    more: '更多',
    importData: '导入数据',
    exportData: '导出数据',
    checkExportData: '勾选导出',
    noImgdownloadData: '无图片导出',
    import: '导入',
    export: '导出',
    downloadTemplate: '下载模板',
    print: '打印',
    excel: 'Excel文件(xlsx)',
    pdf: '便携式文档(PDF)',
    exportExcel: '导出Excel',
    exportPdf: '导出PDF',
    cancel: '取消',
    confirm: '确认',
    read: '已读',
    unread: '未读',
    unreaded: '待阅',
    setting: '设置',
    logOut: '退出',
    about: '关于',
    save: '保存',
    temporary: '暂存',
    submit: '提交',
    launch: '发起',
    saveAndCreate: '保存并新增',
    saveAndClose: '保存并关闭',
    close: '关闭',
    clear: '清除填充',
    home: '首页',
    workflowManage: '流程管理',
    reviewReport: '审核',
    cancelReport: '反审',
    voidReport: '作废'
  },
  table: {
    rid: 'RID',
    type: '类型',
    name: '名称',
    loadMore: '点击加载更多',
    noData: '无附件',
    dept_name: '填报部门',
    user_name: '填报人',
    fillDate: '填报时间',
    lastModUser: '最后修改人',
    lastModDate: '最后修改时间',
    toolBar: '操作',
    SN: '序号',
    all: '全部分类'
  },
  dialogTitle: {
    messages: '消息',
    warnings: '预警',
    start: '发起流程',
    appSetting: '应用管理',
    chooseData: '选择数据',
    rollBack: '回退',
    submit: '提交'
  },
  status: {
    success: '成功',
    warning: '提示',
    prompt: '提示',
    error: '失败',
    noMsg: '暂无消息',
    noWarning: '暂无预警',
    noData: '暂无数据',
    noSummary: '暂无摘要'
  },
  schedule: {
    flowChart: '流程图',
    dealDate: '办理时间',
    opinion: '意见',
    note: '说明',
    task: '任务名称',
    handler: '操作人',
    description: '操作类型'
  },
  placeholder: {
    search: '请输入搜索内容'
  },
  messages: {
    workFlowLoading: '流程信息正在加载中，请稍后再试。'
  },
  alert: {
    notFound: '内容未找到',
    saveSuccess: '保存成功',
    noSolution: '没有获取到任何账套信息，请与管理员联系！',
    isRead: '是否标记为已阅？',
    readSuccess: '阅览成功',
    receiveWarning: '你有一条新预警',
    receiveNotification: '你有一条新消息',
    receiveUpcoming: '你有一条新待办',
    fedLogOut: '您的账号已在另一台设备上登录，请重新登录',
    deleteMsg: '是否删除这条消息？',
    delete: '是否删除？',
    workflow: '是否放弃办理？',
    deleteSuccess: '删除成功',
    batchDeleteBefore: '是否删除这',
    batchDeleteAfter: '条记录？',
    batchDeleteSuccess: '批量删除成功',
    lock: '锁定成功',
    unlock: '解锁成功',
    importSuccess: '导入结束',
    notFoundInfo: '没有查询到相关信息',
    notBoundView: '此消息没有绑定查看表单',
    notBoundAssociated: '此消息没有绑定关联表单',
    isLogOut: '是否退出登录？',
    cancelReviewSuccess: '反审完成！',
    cancelReviewFailed: '反审失败！',
    reviewSuccess: '审核完成！',
    reviewFailed: '审核失败！',
    voidSuccess: '作废成功！',
    voidFailed: '作废失败！',
    voidWarning: '作废后单据将无法还原，是否继续？',
    close: '确认关闭单据？'
  },
  error: {
    noRightForWorkFlow: '您没有发起该项流程的权限！',
    noRightForHistory: '您没有查看该历史记录的权限！'
  },
  workflow: {
    myProcess: '我的办理',
    myStart: '我的发起',
    allWorkflow: '全部流程',
    notAllow: '当前流程不满足条件，不允许提交！',
    noMore: '没有更多了',
    loading: '加载中...',
    noProcess: '没有可发起的流程',
    errprPrompt: '流程错误提示',
    submitFail: '由于没有满足条件的步骤，提交失败！',
    batchApproval: '批量审批',
    dealType: '处理方式',
    all: '全部',
    urge: '催办',
    prompt: '过期',
    isUrge: '是否催办？',
    urgeSuccess: '催办成功！',
    mine: '我的发起',
    read: '阅览',
    unprocessed: '提交未处理',
    message: '消息',
    doing: '进行中',
    end: '已结束',
    delete: '可删除',
    todo: '待办事项',
    temporary: '暂存事项',
    unread: '待阅事项',
    done: '已办事项',
    workflow: '流程管理',
    oneNext: '请手动指定下一步执行人',
    moreNext: '有多个满足流程流向的节点，请选择下一步的审批流向',
    hasWorkflow: '当前模板有多个可发起的流程',
    noTemplate: '发起步骤未绑定表单，是否直接提交当前流程？',
    submitTitle: '流程走向',
    rollBackOpinion: '回退意见',
    rollBackType: '回退类型',
    chooseRollBackOpinion: '请选择回退意见',
    enterRollBackOpinion: '请输入回退意见',
    isBack: '是否退回？',
    backward: '退回到上一步',
    backhead: '退回到开头',
    backappoint: '退回到指定步骤',
    backSuccess: '回退成功',
    submitSuccess: '提交成功',
    temporarySuccess: '暂存成功',
    SubmitOpinion: '提交意见',
    SubmitType: '提交类型',
    chooseSubmitOpinion: '请选择提交意见',
    enterSubmitOpinion: '请输入提交意见',
    isSubmit: '是否提交？',
    failSubmit: '提交失败，没有满足流向条件的下一步节点，请选择处理方式',
    temporarySubmit: '没有满足流向条件的下一步节点，将',
    isRedo: '是否撤回？',
    redoSuccess: '撤回成功',
    noneSchedule: '当前流程还没有任何提交任务'
  },
  setting: {
    language: '语言',
    big3: '加宽Ⅲ',
    big2: '加宽Ⅱ',
    big1: '加宽Ⅰ',
    small3: '紧凑Ⅲ',
    small2: '紧凑Ⅱ',
    small1: '紧凑Ⅰ',
    normal: '常规',
    leftSeptum: '左侧间隔',
    emailPass: '邮箱密码',
    email: '邮箱地址',
    mail: '邮箱设置',
    avatar: '个人设置',
    nickname: '姓名',
    password: '密码设置',
    avatarMaxSize: '最大不能超过2MB',
    oldPass: '原密码',
    newPass: '新密码',
    checkPass: '确认密码',
    signature: '签名',
    nicknameSuccess: '昵称修改成功',
    passwordSuccess: '密码修改成功',
    UI: '系统界面'
  },
  workflowTable: {
    name: '流程名称',
    step: '步骤名称',
    note: '摘要描述',
    creator: '创建人',
    createDate: '创建日期',
    handler: '办理人',
    dealDate: '办理日期',
    startDate: '创建日期'
  },
  validation: {
    passwordDiff: '两次输入的密码不一致！',
    nickname: '账户昵称不能为空',
    email: '请输入邮箱地址',
    errorMail: '请输入正确的邮箱地址',
    emailPass: '请输入邮箱密码'
  },
  theme: {
    default: '默认皮肤',
    ywcq: '仰望苍穹',
    qqzj: '青青子衿',
    fyhl: '枫叶红了'
  },
  mail: {
    selectUser: '选择用户',
    user: '用户',
    dept: '部门',
    title: '邮件发送',
    address: '收件人',
    copy: '抄送',
    subject: '主题',
    body: '正文',
    attach: '附件',
    send: '发 送',
    cancel: '取 消',
    success: '发送成功！',
    isCancel: '确认取消发送？'
  },
  report: {
    noRecord: '未找到记录！',
    delete: '删除',
    modify: '修改',
    download: '下载',
    preview: '预览',
    upload: '上传',
    integer: '请输入一个正整数',
    extendRow: '请输入扩展行数',
    extendColumn: '请输入扩展列数',
    rowError: '模板文件有误！扩展行失败',
    insertRowError: '插入的行超出了有效编辑范围！',
    insertColumnError: '插入的列超出了有效使用范围！建议使用大数据模式扩充有效行。',
    deleteRowError: '模板文件有误！删除行失败',
    lessThan2Row: '扩展表区域不得低于两行！',
    lessThan2Column: '扩展表区域不得低于两列！',
    cannotDelete: '该行无法删除！',
    mainTableNotClear: '主表不支持清空全部数据',
    dataSheet: '数据表',
    alias: '别名',
    field: '字段',
    notInTemp: '在模板中不存在！',
    notSupportAutomatic: '您使用的浏览器不支持自动统计功能！',
    processError: '流程信息初始化失败！',
    noEditRights: '您对本单据没有编辑权限！',
    advancedPermissionError: '单据高级权限获取失败！',
    templateError: '初始化模板属性失败！',
    nothingDesigned: '该模板未设计任何内容！',
    emptyTemp: '模板文件为空！',
    tempFileError: '获取模板文件失败！',
    printAreaError: '处理打印区域失败！',
    queryFormulaError: '取数公式初始化失败！',
    linkError: '超链接初始化失败！',
    paramError: '参数信息错误！',
    triggerCustom: '触发自定义按钮',
    backFormulaExecuteError: '回写公式执行失败！步骤ID ',
    actionError: '动作执行失败！步骤ID ',
    undefinedAction: '未定义的动作事件类型！',
    mailParamError: '整理邮件参数数据错误！',
    mailSettingError: '邮件发件设置不存在或时机不正确！',
    saveField: '保存失败！',
    reportEmpty: '获取单据内容为空！',
    documentConentError: '打开单据内容失败！',
    crossTableFillError: '暂不支持交叉表快速填充！',
    stateError: '单据状态切换异常！',
    uploadTryLater: '正在上传文件，请稍候再试！',
    editLockError: '编辑锁获取失败！请重新打开修改！',
    uploading: '正在上传图片附件',
    completed: '已完成',
    uploaded: '选择的内容已全部上传完毕！',
    uploadFail: '上传文件失败！',
    duplicate: '字段违反当前表组合唯一要求，请不要填写重复的值！',
    duplicateValue: '重复，重复值为',
    crosstab: '交叉表',
    dataFormatError: '数据内容不符合格式要求！',
    isRequired: '为必填项！',
    exceedLimit: '字符数量超过了限制！',
    digitsLimit: '数字位数超过了限制！',
    mustNumber: '值必须为数字！',
    mustDate: '值必须为日期！',
    legalDate: '值必须为合法的日期！',
    contentLimit: '内容超过数量限制！',
    legalID: '不是一个合法的身份证！',
    legalEmail: '不是一个有效的邮箱',
    mobileVaild: '不是一个有效的手机号码！',
    phoneVaild: '不是一个有效的座机号码！',
    openReportFailed: '打开单据失败！',
    editState: '该记录处于编辑状态！',
    editLockError1: '重新修改可能会产生错误！',
    unkonwn: '未知错误！',
    cascadError: '级联下拉打开失败！',
    automaticNmberError: ' 的自动编号获取失败！',
    dropDownError: ' 的下拉列表获取失败！',
    listError: '列表打开失败！',
    noListAvailable: '无列表可选！',
    corsstabDimension: '交叉表关联填充的内容必须在同一个维度上！',
    dataSheetType: '数据表类型',
    notExist: '不存在！',
    otherTable: '暂不支持取其他扩展表值！',
    noSignature: '未找到签名！',
    defaultSignature: '请先设置默认签名！',
    waiting: '正在执行，请稍候。。。',
    noDataObtained: '未取得任何数据！',
    queryFail: '取数公式执行失败！',
    queryTimingError: '取数公式执行时机错误！',
    styleTimingError: '动态样式执行时机错误！',
    styleError: '动态样式执行失败！',
    formatError: '条件格式初始化失败！',
    alasqlError: 'AlaSQL数据表创建失败！',
    fieldFailLegal: '本报表扩展表取值失败！请检查引用是否合法。',
    illegalOperation: '不合法的操作，已拦截',
    addRow: '添加行',
    deleteRow: '删除行',
    customRows: '自定义行数',
    addColumn: '添加列',
    deleteColumn: '删除列',
    customColumns: '自定义列数',
    isDiscard: '是否确定放弃更改？',
    printArea: '请先设置打印区域！',
    noInfo: '没有查询到相关信息',
    clearFill: '清除填充',
    delimiter: '分隔符',
    row: '行',
    column: '列',
    uploadSelect: '正在上传选择的内容',
    inputRemark: '请输入备注信息',
    temporarySuccess: '暂存完成，请继续编辑。',
    illegalTemporary: '保存失败！暂存记录已被提交，请核对！'
  },
  preview: {
    import: '开始导入',
    chooseFile: '选择文件',
    errorFile: '错误日志',
    timeCost: '耗费时间',
    failedCount: '失败数量',
    importCount: '成功数量',
    importType: '导入类型',
    importMethod: '导入方式',
    links: '条满足链接条件',
    executionSucceed: '执行成功！',
    executionFailed: '执行失败！',
    isExecut: '确定执行？',
    downloadFailed: '文件下载失败！',
    oneFile: '一次只能选择一个文件！',
    fileLimit: '上传文件大小超出了限制！',
    partSuccess: '部分数据导入成功，请查看错误列表。',
    importFail: '导入失败！',
    exportFail: '数据导出失败！',
    noMasterField: '无法生成模板，请定义至少一个主表字段！',
    noCreatePermission: '您没有新建权限',
    deleteTemporary: '即将删除暂存的记录, 是否继续？'
  },
  attach: {
    download: '下载',
    title: '附件列表',
    batchDownload: '批量下载',
    preview: '文件预览',
    prepare: '正在准备文件，请稍候...',
    downloading: '下载中',
    processing: '处理中，请稍候...',
    notSupport: '暂不支持该格式文件预览，请下载至本地查看。',
    downloadAll: '下载所有图片',
    donwloadFail: '文件下载失败！',
    infoFail: '文件信息获取失败！',
    imgFail: '图片获取失败！',
    attachFail: '附件获取失败！',
    notSet: '未设置预览组件，无法直接预览'
  },
  listview: {
    pick: '选择',
    viewSelected: '已选',
    selected: '已选数据',
    deleteAll: '全部删除',
    isClearAll: '确定清空所有已选项？',
    oneRecord: '请至少选择一条记录！',
    validRecord: '请选择一条有效的记录！'
  },
  location: {
    location: '定位',
    setStart: '设为起点',
    setEnd: '设为终点',
    walking: '步行',
    driving: '驾车',
    transit: '公交',
    routeName: '路线名称',
    noTransit: '无公交路线',
    km: '公里',
    m: '米',
    minutes: '分钟',
    hour: '小时'
  },
  reset: {
    reset: '重置密码',
    back: '返回登录',
    fill: '填写账号',
    auth: '身份验证',
    setNew: '设置新密码',
    complete: '完成',
    email: '电子邮箱',
    code: '验证码',
    next: '下一步',
    sendToEmail: '验证码已发送至您的邮箱',
    emailCode: '邮箱验证码',
    resetSuccess: '重置密码成功',
    logNew: '您可以使用新密码登录',
    codeRequired: '验证码不能为空',
    codeError: '验证码不正确',
    passRequired: '请输入密码',
    passAgain: '请再次输入密码',
    twoPass: '两次输入密码不一致',
    emailRequired: '请输入邮箱地址',
    correctEmail: '请输入正确的邮箱地址'
  },
  register: {
    username: '姓名',
    usernameRequired: '姓名不能为空',
    codeRequired: '激活码不能为空',
    code: '激活码',
    state: '验证码',
    register: '用户注册',
    basic: '基本信息',
    mailVaild: '账号激活',
    loginName: '登录名',
    password: '密码',
    registerSuccess: '注册成功，您可返回登录Workfine'
  },
  print: {
    preview: '打印预览'
  }
}
